// extracted by mini-css-extract-plugin
export var Hero = "style-module--Hero--12fbf";
export var HeroContainer = "style-module--HeroContainer--061a0";
export var Image = "style-module--Image--8d569";
export var ImagePrefix = "style-module--ImagePrefix--6dc4f";
export var Intro = "style-module--Intro--6a01f";
export var Subtitle = "style-module--Subtitle--aa123";
export var Title = "style-module--Title--4f076";
export var heroImage = "style-module--heroImage--9e361";
export var heroImageCont = "style-module--heroImageCont--20e7f";